import { render, staticRenderFns } from "./ValidaPreaspirante.vue?vue&type=template&id=d2408e6e"
import script from "./ValidaPreaspirante.vue?vue&type=script&lang=js"
export * from "./ValidaPreaspirante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports